import React, { Component } from 'react'
import { connect } from 'react-redux'
import { OrderEventsOverview as OrderEventsOverview23 } from 'projects/flow-gui-access/views/2.3/orderevents'
import { OrderEventsOverview as OrderEventsOverview24 } from 'projects/flow-gui-access/views/2.4/orderevents'

class OrderEventsOverview extends Component {
  render () {
    if (this.props.configReducer.endpoints.filter(endpoint => endpoint.name === 'orderevents' && endpoint.version === '2.3').length !== 0) {
      return <OrderEventsOverview23 {...this.props} />
    } else if (this.props.configReducer.endpoints.filter(endpoint => endpoint.name === 'orderevents' && endpoint.version === '2.4').length !== 0) {
      return <OrderEventsOverview24 {...this.props} />
    } else return false
  }
}
export default connect(state => state)(OrderEventsOverview)



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/middlewares/orderevents/overview.js